import React, { useRef, useState } from "react";
import { T, useTranslateKey } from "../../hooks/useTranslate";

import {
  InputLabel,
  MenuItem,
  FormControl,
  ListItemText,
  Select,
  Radio,
  Box,
} from "@mui/material";

import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import {
  columns,
  getHeaderNameFromFieldName,
} from "../../screens/MyMembersScreen/format-members-columns";

const SortByDropdown = ({ sortModel, handleSortModelChange, loading, searchField }) => {
  const [selectIsOpen, setSelectIsOpen] = useState(false);
  const selectRef = useRef();

  const theme = useTheme();
  const viewportIsSmall = useMediaQuery(theme.breakpoints.up("sm"));

  const subheaderStyle = {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: 10,
    color: "#8A9BB0",
    padding: "16px 24px 0px 26px",
  };

  const field = [sortModel[0].field, sortModel[0].sort];

  const handleSortOptionClick = (e) => {
    ["desc", "asc"].includes(e.currentTarget.getAttribute("value"))
      ? handleSortModelChange([
        { field: field[0], sort: e.currentTarget.getAttribute("value") },
      ])
      : handleSortModelChange([
        { field: e.currentTarget.getAttribute("value"), sort: field[1] },
      ]);
  };

  const getLabel = () => {
    return <Box sx={textStyle}><T>{getHeaderNameFromFieldName(field[0])}</T></Box>
  };

  const onSelectOpenOrClose = (isOpen) => {
    setSelectIsOpen(isOpen);

    if (!isOpen) {
      selectRef.current.classList.remove("Mui-focused");
      selectRef.current.previousSibling?.classList.remove("Mui-focused");
    }
  };

  const translateKey = useTranslateKey;

  const textStyle = {
    fontFamily: "Inter",
    fontWeight: "500",
    fontSize: "14px"
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center" }} id="sort-by-dropdown">
      <FormControl sx={{ width: viewportIsSmall ? 225 : 150 }}>
        {selectIsOpen ? (
          <InputLabel
            id="sort-by-radio-group-label"
            sx={{ color: "#153862" }}
            shrink={selectIsOpen}
          >
            {selectIsOpen ? "Sort By" : ""}
          </InputLabel>
        ) : undefined}
        <Select
          labelId="sort-by-radio-group-label"
          id="sort-by-radio-group"
          ref={selectRef}
          value={[]}
          label={selectIsOpen ? "Sort By" : undefined}
          onOpen={() => onSelectOpenOrClose(true)}
          onClose={() => onSelectOpenOrClose(false)}
          renderValue={() => getLabel()}
          displayEmpty
          multiple
          disabled={loading}
          sx={{
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: "1px solid rgba(145, 158, 171, 0.2)",
              borderRadius: "8px"
            }
          }}
          MenuProps={{
            sx: {
              marginTop: "8px"
            },
            PaperProps: {
              sx: {
                border: "1px solid rgba(145, 158, 171, 0.1)",
                boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(145, 158, 171, 0.1)"
              }
            }
          }}
        >
          <Box id="sort-menu">
            <Box sx={subheaderStyle}><T isUpperCase={true}>sort</T></Box>
            {columns.map(column => (
              <MenuItem
                key={column.field}
                value={column.field}
                data-test-id={column.headerName}
                aria-label={column.headerName}
                onClick={handleSortOptionClick}
                disabled={column.disableWhenNoSearch && !searchField}
              >
                <Radio
                  checked={field.includes(column["field"])}
                  disabled={loading}
                />
                <ListItemText primary={translateKey(column.headerName)} primaryTypographyProps={textStyle} />
              </MenuItem>
            ))}
            <Box sx={subheaderStyle}><T isUpperCase={true}>order</T></Box>
            <MenuItem
              key={"desc"}
              value={"desc"}
              data-test-id={`desc-listitem`}
              aria-label="Descending"
              onClick={handleSortOptionClick}
              disabled={loading}
            >
              <Radio checked={field.includes("desc")} />
              <ListItemText primary={translateKey("descending")} primaryTypographyProps={textStyle} />
            </MenuItem>
            <MenuItem
              key={"asc"}
              value={"asc"}
              data-test-id={`asc-listitem`}
              aria-label="Ascending"
              onClick={handleSortOptionClick}
              disabled={loading}>
              <Radio checked={field.includes("asc")} disabled={loading} />
              <ListItemText primary={translateKey("ascending")} primaryTypographyProps={textStyle} />
            </MenuItem>
          </Box>
        </Select>
      </FormControl>
    </Box >
  );
};

export { SortByDropdown };
